import { Box, Icon, Text, Tooltip, TooltipPopup, TooltipTrigger } from "@salestrak/ui";
import { isValidPhoneValue } from "@salestrak/custom-fields";
import type { CustomFieldDef } from "./types";

/**
 * Whether a SETTLED phone value should read as flagged. A number that does not
 * fit its region commits rather than being refused (switching a 10-digit
 * number to a 6-digit country must keep the digits), so the rest state is
 * where the problem is stated — red value text plus this marker.
 */
export function isFlaggedPhoneValue(
  field: Pick<CustomFieldDef, "type"> | null | undefined,
  value: unknown,
  hasValue: boolean,
): boolean {
  return field?.type === "phone" && hasValue && !isValidPhoneValue(value);
}

/** The rest-state flag beside an unparseable phone value: an alert glyph whose
 *  tooltip says why the value reads red. */
export function InvalidPhoneMarker() {
  return (
    <Tooltip>
      <TooltipTrigger render={<Box direction="row" align="center" shrink={false} />}>
        <Icon name="alert-circle" size="sm" color="destructive" />
      </TooltipTrigger>
      <TooltipPopup side="top">
        <Text size="xs">Invalid phone number</Text>
      </TooltipPopup>
    </Tooltip>
  );
}
